module.exports = __webpack_public_path__ + "0a2fb019bbc97cc5d94c88c19017e386.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/TWS_gang.jpg
// module id = 624
// module chunks = 0